module.exports = __webpack_public_path__ + "static/media/check-mark.f3a58f45.svg";